module.exports = __webpack_public_path__ + "static/img/case_banner_public_h5.ac7bc24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_public_h5.png
// module id = 97mz
// module chunks = 34